'use client';

import React from 'react';

// eslint-disable-next-line no-restricted-imports
import Link from 'next/link';
import { isExternalLink } from './utils/is-external-link';
type CustomNextLinkProps = React.PropsWithChildren & {
  href: string;
  prefetch?: boolean;
  className?: string;
  key?: string | number | null;
  'aria-label'?: string;
  dir?: 'ltr' | 'rtl';
  target?: '_blank' | '_parent' | '_self' | '_top';
  onClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
};
export const AppNextLink = React.forwardRef<HTMLAnchorElement, CustomNextLinkProps>(({
  href,
  children,
  onClick,
  prefetch,
  className,
  dir,
  'aria-label': ariaLabel,
  target
}, ref) => {
  const isExternal = isExternalLink(href);
  if (isExternal) {
    const handleNavigateToLink = () => {
      target === '_blank' ? window.open(href, '_blank') : window.location.href = href;
    };
    return <div ref={ref as React.Ref<HTMLDivElement>} onClick={e => {
      onClick?.(e);
      setTimeout(() => {
        handleNavigateToLink();
      }, 200);
    }} className={`cursor-pointer ${className}`} aria-label={ariaLabel} dir={dir}>
                    {children}
                </div>;
  }
  return <Link href={href} prefetch={prefetch} className={className} onClick={e => {
    onClick?.(e as unknown as React.MouseEvent<HTMLAnchorElement, MouseEvent>);
  }} ref={ref} dir={dir} aria-label={ariaLabel} target={target}>
                {children}
            </Link>;
});
AppNextLink.displayName = 'AppNextLink';